import { useEffect } from "react";
import { sendScrollMessageToParent, retryHeight, sendBodyHeightToParent } from "../../_helpers/iFrameSize.helper";

export function useIframeAutoHeight(deps: any[] = []) {
    useEffect(() => {
        sendScrollMessageToParent();
    }, []);

    useEffect(() => {
        retryHeight(sendBodyHeightToParent);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
